<template src="@/templates/appFooter/appFooter.html"></template>

<script>
import { mapGetters, mapActions } from "vuex";
import ClockModel from "@/models/clockModel";
import moment from "moment";
import vueMoment from "vue-moment";
import dateRange from "@/components/file/DateRange";
import UploadForm from "@/components/file/UploadForm";
import { moments } from "@/utilities/moments";
import {
  getUA,
  mobileModel,
  mobileVendor,
  osVersion,
  osName,
  fullBrowserVersion,
  deviceType,
  browserName,
} from "mobile-device-detect";

export default {
  name: "appFooter",
  components: {
    dateRange,
    UploadForm,
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    disconnect() {
      console.log("socket disconnected");
    },
  },
  watch: {
    categorySelected: {
      handler: function (after) {
        console.log("after");
        console.log(after);

        if (after != null) Event.$emit("filterResourceListByCategory", after);
      },
      deep: true,
    },
  },
  data() {
    return {
      // currentModel: 'workingWithChildrenModel',
      currentModel: "clearanceCheckModel",
      checkType: "WorkingWithChildrenCheck",
      noEndDate: 0,
      showClockPopup: false,
      clockTitle: "",
      clockInfo: "",
      clockActivity: "",
      fileList: {},
      viewDateRangeComp: false,
      viewUploadFormComp: false,
      clockOffReminder: false,
      jobSlipsReminder: false,
      callToOfficeNotice: false,
      showHealthDeclaration: false,
      showClockOffTimeSelector: false,
      hasImage: false,
      image: null,
      categoryList: [],
      categorySelected: 0,
      clockOffTime: "",
    };
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "isClockOnOff",
      "isAcceptDeclineHide",
      "isAvailUnavailableHide",
      "isSearchHide",
      "isCameraHide",
      "isCamera",
      "isSearch",
      "isResourceCategory",
      "isResourceCategoryHide",
      "getIcon",
      "bookingDetailRefNum",
      "getImageFor",
      "getNoEndDate",
      "getJob",
      "isClockOnOffHide",
      "getScrollStatus",
      "getReturnToComp",
      "isBackButton",
      "isClockOnHide",
      "getCallToOffice",
      "getJobSessionId",
      "getInter_trans",
      "getServiceDate",
      "getServiceStartTime",
      "getServiceEndTime",
    ]),
  },
  mounted() {
    Event.$on("hideDateRangeComp", () => {
      let thisComponent = this;
      setTimeout(function () {
        console.log("hideDateRangeComp");
        thisComponent.resetCurrentFile();
        thisComponent.viewDateRangeComp = false;
      }, 50);
    });

    Event.$on("hideUploadFormComp", () => {
      let thisComponent = this;
      setTimeout(function () {
        console.log("hideUploadFormComp");
        thisComponent.resetCurrentFile();
        thisComponent.viewUploadFormComp = false;
      }, 50);
    });

    Event.$on("backToUploadDetailsComp", () => {
      let thisComponent = this;
      setTimeout(function () {
        thisComponent.viewUploadFormComp = false;
        thisComponent.resetCurrentFile();
        thisComponent.goBack();
      }, 50);
    });

    Event.$on("resourceCategoryList", (categoryList) => {
      let thisComponent = this;
      setTimeout(function () {
        thisComponent.categoryList = categoryList;

        thisComponent.categoryList.unshift({
          interpreter_resource_category_id: 0,
          category: "-- Select category here--",
          type: null,
        });

        thisComponent.categorySelected = 0;
      }, 50);
    });

    Event.$on("hideFileViewComp", (isThis) => {
      console.log("kmksn");
      console.log(isThis);
      if (isThis === this.isThis) {
        let thisComponent = this;
        setTimeout(function () {
          console.log("kmksn");
          console.log(isThis);
          thisComponent.viewFileViewUploadedComp = false;
        }, 50);
      }
    });
  },
  methods: {
    ...mapActions([
      "updateSearchPopUpShow",
      "updateBackButton",
      "updateCameraState",
      "updateJobRefNum",
      "updateScrollStatus",
      "updateSearchedDate",
      "updateJobSessionId",
    ]),
    setCurrentClockOffTime() {
      let currentDateTime = moment();
      this.clockOffTime = currentDateTime.format("HH:mm");
    },
    disableFooterIcon(status, color) {
      if (status) {
        return "iconHoverStyle" + (color ? color : "");
      } else {
        return "footerIconDisabled";
      }
    },
    iconStyleDisabled(status) {
      if (status) return "iconStyle";
      else return "iconStyleDisabled";
    },
    readFileAsDataURL(event) {
      let file = event.target.files[0];
      console.log("file");
      console.log(file);

      let thisComp = this;
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        console.log(reader.result);
        thisComp.hasImage = true;
        thisComp.fileList = {
          dataUrl: reader.result,
          info: {
            type: file.type,
            name: file.name,
          },
        };

        thisComp.processImage();

        console.log("thisComp.fileList");
        console.log(thisComp.fileList);
      };
      reader.onerror = function (error) {
        this.showNotification(
          "danger",
          "Error Occurred: " + error,
          "error",
          "Error"
        );
      };
    },
    setImageInput(output) {
      this.hasImage = true;
      this.fileList = output;
    },
    processImage() {
      console.log("dcmdkmckdmckdck");
      switch (this.getImageFor) {
        case "jobSlips": {
          this.viewUploadFormComp = true;
          break;
        }
        default: {
          this.currentModel = "clearanceCheckModel";
          this.checkType = this.getImageFor;
          this.noEndDate = this.getNoEndDate;
          this.viewDateRangeComp = true;
          break;
        }
      }
    },
    showClock(status) {
      if (status) {
        this.clockTitle = "Clock On";
        this.clockInfo = "Are you sure you want to clock on?";
        this.clockActivity = "clockon";
      } else {
        this.clockTitle = "Clock Off";
        this.clockInfo = "Are you sure you want to clock off?";
        this.clockActivity = "clockoff";
      }

      this.showClockPopup = true;
      this.showHealthDeclaration = false;
    },
    healthDeclarationFunc() {
      for (const item of this.getCallToOffice) {
        if (item == this.bookingDetailRefNum) {
          this.callToOfficeNotice = true;
          return;
        }
      }

      if (this.callToOfficeNotice == false) {
        if (this.getInter_trans == "Ph Int" || this.getInter_trans == "Video") {
          this.showClock(true);
          return;
        }

        if (this.getJobSessionId > 0) {
          window.open("https://sessional.allgraduates.com.au/", "_blank");
        } else {
          let data = {
            jobID: this.bookingDetailRefNum,
            serviceDate: moment(this.getServiceDate).format(
              "dddd Do of MMMM YYYY"
            ),
            token: localStorage.getItem("jwt"),
          };

          let clockModel = new ClockModel();
          clockModel
            .clockActivityFunc("Health Declaration", data)
            .then((responseCondition) => {

              let response = responseCondition.response.data;

              if (response.error == false) {
                this.showHealthDeclaration = true;
                this.clockInfo = response.template;
              } else {
                this.showNotification(
                  "danger",
                  "Contact All Graduates",
                  "error",
                  "Error"
                );
              }
            })
            .catch((error) => {

              this.showNotification(
                "danger",
                error + ". Contact All Graduates",
                "error",
                "Error"
              );
            });
        }
      }
    },
    healthDeclarationRejected() {
      this.showHealthDeclaration = false;

      let data = {
        jobID: this.bookingDetailRefNum,
        clockOnConditionsID: 1,
        nonSessionalBookings: "Onsite",
      };

      let clockModel = new ClockModel();
      clockModel
        .clockActivityFunc("Health Declaration Rejected", data)
        .then((responseCondition) => {
          let response = responseCondition.response.data;

          if (response.error == false) {
            this.showNotification(
              "danger",
              response.message,
              "error",
              "Action Required"
            );
          } else {
            this.showNotification(
              "danger",
              "Contact All Graduates",
              "error",
              "Error"
            );
          }
        })
        .catch((error) => {
          this.showNotification(
            "danger",
            error + ". Contact All Graduates",
            "error",
            "Error"
          );
        });
    },
    updateClockActivity() {
      if (
        this.clockActivity == "clockoff" &&
        this.showClockOffTimeSelector == false
      ) {
        this.setCurrentClockOffTime();
        this.showClockOffTimeSelector = true;
        this.showClockPopup = false;
        return;
      }

      let startTime = this.getServiceStartTime;
      let jobOriginalEndTime = this.getServiceEndTime;
      let endTime = this.clockOffTime ? this.clockOffTime + ":00" : "";
      if (this.clockActivity == "clockoff" && startTime >= endTime) {
        this.showNotification(
          "danger",
          "Clock-Off Time must be greater than Clock-On time!",
          "error",
          "Warning"
        );
        return;
      }

      let currentDate = new Date();
      let currentTime = moment(currentDate).format("HH:mm:ss");
      let dateNow = moment(currentDate).format("YYYY-MM-DD");
      if (this.clockActivity == "clockoff" && endTime > currentTime) {
        this.showNotification(
          "danger",
          "Clock-Off Time must be either lesser than or equal to Current time!",
          "error",
          "Warning"
        );
        return;
      }

      let isClockOffWithin10Minutes = false;
      if (this.clockActivity == "clockoff") {
        let endTimeAsUnix = moments.formatDateTimeAsUnix(
          dateNow + " " + endTime
        );

        let subtract10MinutesOnEndTimeAsUnix = moments.formatDateTimeAsUnix(
          moments.subtractFromDateTime(
            dateNow + " " + jobOriginalEndTime,
            10,
            "minutes"
          )
        );

        let add10MinutesOnEndTimeAsUnix = moments.formatDateTimeAsUnix(
          moments.addFromDateTime(
            dateNow + " " + jobOriginalEndTime,
            10,
            "minutes"
          )
        );

        /** Is end time entered by interpreter is within +-10 minutes of actual job end time **/
        if (
          endTimeAsUnix <= add10MinutesOnEndTimeAsUnix &&
          subtract10MinutesOnEndTimeAsUnix <= endTimeAsUnix
        ) {
          isClockOffWithin10Minutes = true;
        }
      }

      this.showClockOffTimeSelector = false;

      this.$vs.loading();
      let data = {
        jobID: this.bookingDetailRefNum,
        token: localStorage.getItem("jwt"),
        time: currentTime,
        clockOffTime: endTime,
        isClockOffWithin10Minutes: isClockOffWithin10Minutes,
        browser: {
          ua_type: getUA,
          os_number: osVersion,
          os: osName,
          browser_name: browserName,
          browser_version: fullBrowserVersion,
          device_type: deviceType
            ? deviceType +
              " - vendor:" +
              mobileVendor +
              " - model:" +
              mobileModel
            : "web",
        },
      };

      let clockModel = new ClockModel();
      clockModel
        .clockActivityFunc(this.clockActivity, data)
        .then((res) => {
          this.$vs.loading.close();
          console.log(res);
          this.showClockPopup = false;

          if (this.clockActivity == "clockon") {
            this.clockOffReminder = true;

            let dataAcknowledged = {
              jobID: this.bookingDetailRefNum,
              clockOnConditionsID: 1,
              serviceDate: this.getServiceDate,
              serviceTimeStart: this.getServiceStartTime,
              serviceTimeEnd: this.getServiceEndTime,
              nonSessionalBookings: "Onsite",
            };

            clockModel
              .clockActivityFunc(
                "Health Declaration Acknowledged",
                dataAcknowledged
              )
              .then((resp) => {
                let response = resp.response.data;

                if (response.error == false) {
                  this.showNotification(
                    "primary",
                    response.message,
                    "notification_important",
                    "Info"
                  );
                } else {
                  this.showNotification(
                    "danger",
                    "Contact All Graduates",
                    "error",
                    "Error"
                  );
                }
              })
              .catch((error) => {
                this.showNotification(
                  "danger",
                  error + ". Contact All Graduates",
                  "error",
                  "Error"
                );
              });

            this.$socket.emit("client-message", {
              type: "activityController",
              data: {
                job_id: this.bookingDetailRefNum,
                key: "is_clocked_on",
              },
            });
          } else {
            if (this.clockActivity == "clockoff") {
              let response = res.response.data;
              let key = "is_clocked_off";
              if (response.data.userTimeEnd < response.data.jobTimeEnd)
                key = "early_clock_off";

              this.$socket.emit("client-message", {
                type: "activityController",
                data: {
                  job_id: this.bookingDetailRefNum,
                  key: key,
                  value: 1,
                },
              });
            }

            this.jobSlipsReminder = true;
          }

          this.showNotification(
            "success",
            this.clockTitle + " Successful!",
            "check_box",
            "Success"
          );
          Event.$emit("refreshBookingDetail");
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
          this.showNotification(
            "danger",
            "Unable to " + this.clockTitle,
            "error",
            "Error"
          );
          // debugger;
        });
    },
    acceptBooking(status) {
      Event.$emit("acceptDeclineBookings", status);
    },
    availUnavailability(status) {
      Event.$emit("availUnavailabilityBookings", status);
    },
    searchJobs() {
      Event.$emit("invokeSearchPopUp");
    },
    viewImage() {
      Event.$emit("viewFileViewComp");
    },
    goBack() {
      this.$router.push({ name: this.getReturnToComp });
    },
    back() {
      console.log(";s,l,sx");
      this.updateBackButton(false);
      this.updateScrollStatus(false);
      this.updateSearchedDate(this.$route.query.startDate);
      this.updateJobSessionId();

      if (this.$route.query.booking_view == "sd_pending") {
        this.$router.push({
          path:
            "/SDPending/" +
            this.$route.query.type +
            "/" +
            this.$route.query.booking_view,
        });
      } else {
        this.$router.push({ name: this.getReturnToComp });
      }
    },
    resetCurrentFile() {
      this.hasImage = false;
      this.fileList = {};
      this.$refs.getImageUploader = {};
    },
    showNotification(color, text, icon, title = "") {
      this.$vs.notify({
        title: title,
        text: text,
        color: color,
        icon: icon,
        position: "top-right",
      });
    },
  },
};
</script>

<style>
input >>> #fileInput {
  overflow: visible;
  display: none !important;
}
</style>

<style scoped>
#resource >>> select {
  background-image: linear-gradient(45deg, transparent 50%, #f8ab52 60%),
    linear-gradient(135deg, #f8ab52 40%, transparent 50%) !important;
  background-position: calc(100% - 30px) 20px, calc(100% - 20px) 20px, 100% 0;
  background-size: 9px 9px, 11px 6px;
  background-repeat: no-repeat;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 43px !important;
}
</style>
